module.exports = __webpack_public_path__ + "img/ic_arrow_left.5f0447df.svg";